const resetStateMixin = Base => class extends Base {
  static DEFAULT_STATE = {}
  state = this.constructor.DEFAULT_STATE

  handleClose() {
    this.setState(this.constructor.DEFAULT_STATE, this.props.onClose);
  }
  handleClose = this.handleClose.bind(this);
};

export default resetStateMixin;



// WEBPACK FOOTER //
// ./client/app/shared/mixins/resetter.js